import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_IMPUESTOS;

const RETENCION = "retencion";
const PERCEPCION = "percepcion";

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function getRetencionForPayment(param = {}) {
  return wsService.make_post_request(section + "/get_retencion_for_payment", param);
}

function getRetencionesForPayment(param = {}) {
  return wsService.make_post_request(section + "/get_retenciones_for_payment", param);
}

function getPercepcionForVoucher(param = {}) {
  return wsService.make_post_request(section + "/get_percepcion_for_voucher", param);
}

function getAgenteRecaudacionImpuestos(param = {}) {
  return wsService.make_post_request(section + "/get_agente_recaudacion_impuestos", param);
}

export const impuestosService = {
  filter,
  getRetencionForPayment,
  getRetencionesForPayment,
  getPercepcionForVoucher,
  getAgenteRecaudacionImpuestos,
  RETENCION,
  PERCEPCION,
};
